module.exports = __webpack_public_path__ + "officialStatic/img/money-second.5a8f2a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/xplan/money-second.png
// module id = ++r1
// module chunks = 0